<div class="flex">
    <ng-content select="carouselItem">
    </ng-content>
</div>
